import { render } from "./ListeEtudiant.vue?vue&type=template&id=ca5083b8&ts=true"
import script from "./ListeEtudiant.vue?vue&type=script&lang=ts"
export * from "./ListeEtudiant.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__